import { useEffect, useReducer } from "react";
import { dataGridReducer } from './dataGridReducer';

export const useDataGridReducer = (initialState) => {
  const [state, dispatch] = useReducer(dataGridReducer, initialState);

  const setBaseGridState = (payload) =>
    dispatch({ type: 'UPDATE_BASEGRID_STATE', payload });

  const setDualGridState = (payload) =>
    dispatch({ type: 'UPDATE_DUALGRID_STATE', payload });

  const setOverviewGridState = (payload) =>
    dispatch({ type: 'UPDATE_OVERVIEWGRID_STATE', payload });

  return {
    dataGridState: state,
    baseGridState: state.basicGridState,
    dualGridState: state.dualGridState,
    overviewGridState: state.overviewGridState,
    setBaseGridState,
    setDualGridState,
    setOverviewGridState,
  };
}